export default {
      id: "icon-counter-usage",
      viewBox: "0 0 28 17",
      url: __webpack_public_path__ + "icons.svg#icon-counter",
      toString: function () {
        return this.url;
      }
    }